import axiosInstance from "../../config/axiosInstance";

const getCompanyUser = () => {
  const response = axiosInstance.dillApi().get("/companies/users");
  return response;
};

export default getCompanyUser;
